import { reflect } from '@effector/reflect';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { breakpoints } from 'shared/lib';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import ActivateIcon from 'shared/ui/assets/activate-icon.svg?react';
import { CompletePromocodeModel } from '../../model';
import cls from './complete-promocode-modal.module.scss';

export const createCompletePromocodeModal = (model: CompletePromocodeModel) => {
	const ConfirmModal = createConfirmModal(model);

	const CompletePromocodeModal = forwardRef<HTMLDivElement, ConfirmModalProps>(
		({ ...props }, ref) => {
			const { t } = useTranslation();

			const md = useUnit(breakpoints.md);

			return (
				<ConfirmModal
					ref={ref}
					title={
						<span className={cls.completePromocodeModalTitle}>{t('complete-promocode.title')}</span>
					}
					submitButtonProps={{
						children: t('complete-promocode.complete'),
						leftSection: <ActivateIcon />,
						variant: 'primary',
						size: md ? 'xl' : 'lg',
						fullWidth: true,
						'data-test-id': 'complete-promocode-submit',
					}}
					variant='default'
					size={md ? '2xl' : 'xl'}
					{...props}
				>
					<span className={cls.completePromocodeModalDescription}>
						{t('complete-promocode.description')}
					</span>
				</ConfirmModal>
			);
		},
	);

	const CompletePromocodeButton = reflect({
		view: ConfirmModal.Button,
		bind: {
			size: breakpoints.md.map((md) => (md ? 'lg' : 'md')),
			variant: 'primary',
			children: breakpoints.md.map((md) => (
				<ActivateIcon
					width={md ? 24 : 16}
					height={md ? 24 : 16}
				/>
			)),
			'data-test-id': 'complete-promocode-button',
		},
	});

	return Object.assign(CompletePromocodeModal, {
		Button: CompletePromocodeButton,
	});
};
